import { CurrencyPipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { I18nService } from '../../services';
import { AppUtils } from '../../utils/app.utils';

@Pipe({
  name: 'currency',
  standalone: false,
})
export class CustomerCurrencyPipe implements PipeTransform {

  private readonly i18nService: I18nService = inject(I18nService);

  transform(value: number | string | null | undefined,
            currencyCode?: string,
            display: 'code' | 'symbol' | 'symbol-narrow' | string | boolean = 'symbol-narrow',
            decimalDigit: number = -0.1,
            digitsInfo?: string,
            locale?: string,
  ): string | null {
    const newValue: number = ((value ?? 0) as number) / (
      decimalDigit !== -0.1 ? Math.pow(10, decimalDigit) : AppUtils.getCurrentStore().defaultPriceDivisorValue
    );
    const currencyLocale: string | null = this.i18nService.getCurrencyLocale();
    if (currencyLocale === 'en-in') {
      const stringValue: string = (value ?? 0).toString();
      const stringValueLength: number = stringValue.length;
      const currencySymbol: string = '\u{20B9}';
      let decimalPart: string = stringValue.slice(-2);
      if (decimalPart.length === 1) {
        decimalPart = '0' + decimalPart;
      }
      let lastThree: string = stringValue.substring(stringValueLength - 5, stringValueLength - 2);
      const otherNumbers: string = stringValue.substring(0, stringValueLength - 5);
      if (otherNumbers != '') {
        lastThree = ',' + lastThree;
      }
      if (lastThree == '') {
        lastThree = '0';
      }
      const output: string = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree + '.' + decimalPart; //NOSONAR
      return currencySymbol + output;
    }
    if (currencyLocale === 'da-dk') {
      return new CurrencyPipe(currencyLocale, 'DKK').transform(
        newValue, 'DKK', display, digitsInfo, locale);
    }

    const formattedCurrency: string = new CurrencyPipe(currencyLocale ?? '', currencyCode).transform(
      newValue, currencyCode, display, digitsInfo, locale) ?? '';

    if (display && display === 'code') {
      const firstDigit: number = formattedCurrency.search(/\d/);

      return formattedCurrency.substring(0, firstDigit) + ' ' + formattedCurrency.substring(firstDigit);
    }

    return formattedCurrency;
  }
}
